import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AdminAuthProvider } from "./AdminAuthContext";
import { EditorGuardProvider } from "./EditorGuard";
import Protected from "./components/Protected";
import AdminLayout from "./components/AdminLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import ProductEditor from "./pages/ProductEditor";
import Categories from "./pages/Categories";
import Brands from "./pages/Brands";
import HomepageBuilder from "./pages/HomepageBuilder";
import HeroManager from "./pages/HeroManager";
import MediaSections from "./pages/MediaSections";
import Offers from "./pages/Offers";
import Reviews from "./pages/Reviews";
import Publish from "./pages/Publish";
import Orders from "./pages/Orders";
import Payments from "./pages/Payments";
import ShippingSettings from "./pages/ShippingSettings";
import CartRecovery from "./pages/CartRecovery";
import MetaReport from "./pages/MetaReport";
import FooterSettings from "./pages/FooterSettings";
import Analytics from "./pages/Analytics";

export default function AdminApp() {
  useEffect(() => {
    // /admin escluso da Google: noindex a livello pagina.
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    document.head.appendChild(meta);
    const prevTitle = document.title;
    document.title = "RINOVA Admin";
    return () => {
      if (meta.parentNode) meta.parentNode.removeChild(meta);
      document.title = prevTitle;
    };
  }, []);

  return (
    <AdminAuthProvider>
      <EditorGuardProvider>
        <div className="admin-root min-h-screen bg-ink font-sans text-chalk antialiased">
          <Routes>
            <Route path="/admin/login" element={<Login />} />
            <Route element={<Protected />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<Dashboard />} />
                <Route path="/admin/statistiche" element={<Analytics />} />
                <Route path="/admin/ordini" element={<Orders />} />
                <Route path="/admin/pagamenti" element={<Payments />} />
                <Route path="/admin/spedizioni" element={<ShippingSettings />} />
                <Route path="/admin/recupero-carrelli" element={<CartRecovery />} />
                <Route path="/admin/report-meta" element={<MetaReport />} />
                <Route path="/admin/footer" element={<FooterSettings />} />
                <Route path="/admin/homepage" element={<HomepageBuilder />} />
                <Route path="/admin/hero" element={<HeroManager />} />
                <Route path="/admin/media-sezioni" element={<MediaSections />} />
                <Route path="/admin/prodotti" element={<Products />} />
                <Route path="/admin/prodotti/:id" element={<ProductEditor />} />
                <Route path="/admin/offerte" element={<Offers />} />
                <Route path="/admin/recensioni" element={<Reviews />} />
                <Route path="/admin/categorie" element={<Categories />} />
                <Route path="/admin/marchi" element={<Brands />} />
                <Route path="/admin/pubblicazione" element={<Publish />} />
              </Route>
            </Route>
            <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </div>
      </EditorGuardProvider>
    </AdminAuthProvider>
  );
}
